<div style="position:absolute; vertical-align: middle; align-content:center; left: 800px; top: 400px;" *ngIf="loading">
  <mat-spinner> </mat-spinner>
</div>
<div class="ttmodal" *ngIf="isCategoeryEdit">
  <div class="ttmodal__header">
    <span *ngIf="isParent" class="ttmodal__title">Edit Category</span>
    <span *ngIf="!isParent" class="ttmodal__title">Edit Section</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body_othersection">
    <div class="input-container">
      <span *ngIf="isParent" class="label">Category Name <span class="red-text"></span></span>
      <span *ngIf="!isParent" class="label">Section Name <span class="red-text"></span></span>
      <input [(ngModel)]="Name" type="text" placeholder="Name" required>
    </div>
  </div>
  <div class="ttmodal__footer">
    <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
    <a class="button button--primary" (click)="onEditategory()"><span class="button__text">Update</span></a>
  </div>
</div>
<div class="ttmodal" *ngIf="isCategoery">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Add Category</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body_othersection">
    <div class="input-container">
      <span class="label">Category Name <span class="red-text"></span></span>
      <input [(ngModel)]="categoryName" type="text" placeholder="Category Name" required>
    </div>
  </div>
  <div class="ttmodal__footer">
    <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
    <a class="button button--primary" (click)="onAddCategory()"><span class="button__text">Add Category</span></a>
  </div>
</div>
<div class="ttmodal" *ngIf="isSection">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Add Section</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body_othersection">
    <div class="input-container">
      <span class="label">Section Name <span class="red-text"></span></span>
      <input [(ngModel)]="sectionName" type="text" placeholder="Section Name" required>
    </div>
  </div>
  <div class="ttmodal__footer">
    <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
    <a class="button button--primary" (click)="onAddSection()"><span class="button__text">Add Section</span></a>
  </div>
</div>
<div class="ttmodal" *ngIf="isQuestionEdit || isQuestion">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Add Question</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body">
    <div class="input-container">
      <span class="info" title="This is the actual question you want answered."><i class="material-icons sc-icon">info</i></span>
      <span class="label">Question <span class="red-text">*</span></span>
      <textarea [(ngModel)]="QTitle" type="text" placeholder="Question" required class="textarea"></textarea>
    </div>
    <div class="input-container">
      <span class="info" title="Add any additional details or instructions that may be required to assist users with answering the question.">
        <i class="material-icons sc-icon">info</i>
      </span>
      <span class="label">Instruction</span>
      <textarea [(ngModel)]="QDescription" type="text" placeholder=" Instruction" class="textarea"></textarea>
    </div>
    <div class="input-container">
      <span class="info" title="Add an image you would like displayed as part of the question">
        <i class="material-icons sc-icon">info</i>
      </span>
      <span class="label">Question Image</span>
      <input type='file' (change)="onSelectImage($event)" accept="image/*">

      <!-- <span class="info" title="This allows users to draw on the question image and have it saved as part of their answer. i.e. have a user mark on the image where a problem has occurred.">
        <i class="material-icons sc-icon">info</i>
      </span>
      <span class="smalllabel">Allow Image Edit</span>
      <mat-checkbox class="checkbox-margin" [(ngModel)]="AllowImageEdit" title="Allow Image Edit"></mat-checkbox>

      <span class="info" title=" Can the user take and add images to their answers">
        <i class="material-icons sc-icon">info</i>
      </span>
      <span class="smalllabel">Allow Images</span>
      <mat-checkbox class="checkbox-margin" [(ngModel)]="AllowImages" title="Allow Images"></mat-checkbox> -->

    </div>
    <div class="input-container">
      <span class="label"> </span>
      <div class="questionimage">
        <img *ngIf="imageUrl" [src]="imageUrl" height="auto" width="100%">
      </div>
    </div>

    <!-- TT-10206 -->
    <div class="input-container">
      <span class="info" title="If checked, the user must enter an answer">
        <i class="material-icons sc-icon">info</i>
      </span>
      <span class="longlabel">Is Answer Mandatory?</span>
      <mat-checkbox class="checkbox-margin" [checked]="isAnswerMandatory" (change)="toggleIsAnswerMandatory()">
      </mat-checkbox>
    </div>

    <div class="input-container">
      <span class="info" title="Check if you need to connect this question with the component">
        <i class="material-icons sc-icon">info</i>
      </span>
      <span class="longlabel">Is Question Connected to a Component</span>
      <mat-checkbox class="checkbox-margin" [(ngModel)]="IsConnectComp" (change)="toggleIsConnectComp()">
      </mat-checkbox>
    </div>
    <div class="input-container">
      <span class="info" title="Select the type of question"><i class="material-icons sc-icon">info</i></span>
      <span class="label">Answer Types <span class="red-text">*</span></span>
      <mat-select placeholder="Select Answer Types" [(ngModel)]="questionTypeId" class="new-input-select get-Input">
        <mat-option *ngFor="let type of QuestionTypes" [value]="type.Id" (click)="ChangeOption()">{{type.Title}}</mat-option>
      </mat-select>
      <div class="activelimit">
        <span class="longlabel">Active Limits for Answers </span>
        <mat-checkbox class="checkbox-margin" [checked]="IsLimitActive" (change)="onLimitActiveChange($event.checked)"> </mat-checkbox>
      </div>
    </div>
    <div class="input-container" *ngIf="questionTypeId==2">
      <span class="info">&nbsp;</span>
      <span class="label">Is Magnetic Plug Question</span>
      <mat-checkbox class="checkbox-margin" [(ngModel)]="IsMagnetic"></mat-checkbox>
    </div>

    <div class="input-container" *ngIf="questionTypeId==1 || questionTypeId ==2 ||  questionTypeId==3">
      <span class="info" title="Enter the available answers for multiple choice and multi-selection questions.">
        <i class="material-icons sc-icon">info</i>
      </span>
      <span class="label">Answers</span>

    </div>
    <div class="input-container" *ngIf="questionTypeId==1">
      <span class="info">&nbsp;</span>
      <span class="label">Option One</span>
      <input class="get-Input new-input1" [(ngModel)]="OptionOne" type="text" placeholder="Question Title">
      <!-- <input *ngIf="IsLimitActive" class="get-Input new-input" [(ngModel)]="StatWorn_1" type="number" placeholder="0% Worn">
      <input *ngIf="IsLimitActive" class="get-Input new-input" [(ngModel)]="EndWorn_1" type="number" placeholder="100% Worn"> -->
    </div>
    <div class="input-container" *ngIf="questionTypeId==1">
      <span class="info">&nbsp;</span>
      <span class="label">Option Two</span>
      <input class="get-Input new-input1" [(ngModel)]="OptionTwo" type="text" placeholder="Question Title">
      <!-- <input *ngIf="IsLimitActive" class="get-Input new-input" [(ngModel)]="StatWorn_2" type="number" placeholder="0% Worn">
      <input *ngIf="IsLimitActive" class="get-Input new-input" [(ngModel)]="EndWorn_2" type="number" placeholder="100% Worn"> -->
    </div>

    <div class="input-container" *ngIf="questionTypeId ==2 ||  questionTypeId==3">
      <span class="info">&nbsp;</span>
      <span class="label">&nbsp;</span>
      <input class="get-Input new-input1 margin" [(ngModel)]="Option" type="text" placeholder="Enter Answer">
      <!-- <input *ngIf="IsLimitActive" class="get-Input new-input" [(ngModel)]="StartWorn" type="number" placeholder="0% Worn">
      <input *ngIf="IsLimitActive" class="get-Input new-input" [(ngModel)]="EndWorn" type="number" placeholder="100% Worn">&nbsp; -->
      <a class="button button--primary" (click)="AddAnswerOption()"><span class="button__text">Add</span></a>
    </div>

    <div class="input-container" *ngFor="let ans of AnswerOptions">
      <span class="info">&nbsp;</span>
      <span class="label">&nbsp;</span>
      <span style="vertical-align: top; width: 165px;">{{ans.Name}}</span>
      <!-- <span *ngIf="IsLimitActive" style="vertical-align: top; width: 120px;">{{ans.StartWorn}}{{ans.StartWorn != null ? "%" : "" }}</span>
      <span *ngIf="IsLimitActive" style="vertical-align: top; width: 120px;">{{ans.EndWorn}}{{ans.EndWorn != null ? "%" : "" }}</span> -->
      <span style="min-width:150px;color: red; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; cursor: pointer; padding-left: 5px;" title="Delete Answer!!">
        <i class="material-icons sc-icon" (click)="RemoveAnswerOption(ans.Id)">remove_circle_outline</i>
      </span>
    </div>


    <!-- <div class="input-container" *ngIf="questionTypeId ==5 && IsLimitActive">
      <span class="info">&nbsp;</span>
      <span class="label">&nbsp;</span>
      <label>0% Worn</label>
      <input class="get-Input new-input" [(ngModel)]="StatWorn_Num" type="number" placeholder="0% Worn">
       <label>100% Worn</label>
      <input class="get-Input new-input" [(ngModel)]="EndWorn_Num" type="number" placeholder="100% Worn">
       <label>Dec. Places</label>
      <input maxlength="1" title="Please enter number from 0 to 4 max." onkeypress="if (Number(this.value) > 4) return false;" class="get-Input new-input" [(ngModel)]="DecimalPlaces" type="number" placeholder="#Dec. Places">
       <label>Select Unit</label>
      <mat-select placeholder="Select Unit" class="get-Input new-input" [(ngModel)]="selectedId" (selectionChange)="onUnitSelected($event.value)">
        <mat-option *ngFor="let unit of unitMeasures" [value]="unit.UnitId">{{unit.UnitMeasure | uppercase}}</mat-option>
      </mat-select>
    </div> -->

  <div class="input-container" *ngIf="questionTypeId == 5" style="justify-content: center;">

  <div class="field-group">
    <label>0% Worn</label>
    <input class="get-Input new-input" [(ngModel)]="StatWorn_Num" type="number" placeholder="0% Worn">
  </div>

  <div class="field-group">
    <label>100% Worn</label>
    <input class="get-Input new-input" [(ngModel)]="EndWorn_Num" type="number" placeholder="100% Worn">
  </div>

  <div class="field-group">
    <label>Dec. Places</label>
    <input maxlength="1"
           title="Please enter number from 0 to 4 max."
           onkeypress="if (Number(this.value) > 4) return false;"
           class="get-Input new-input"
           [(ngModel)]="DecimalPlaces"
           type="number"
           placeholder="#Dec. Places">
  </div>

  <div class="field-group">
    <label>Select Unit Type</label>
    <mat-select placeholder="Select Unit Type" class="get-Input new-input"  [(ngModel)]="selectedTypeId"
                (selectionChange)="onUnitTypeSelected($event.value)">
      <mat-option [value]="4">Length</mat-option>
      <mat-option [value]="6">Pressure</mat-option>
      <mat-option [value]="7">Temperature</mat-option>
    </mat-select>
  </div>

  <div class="field-group">
    <label>Select Unit</label>
    <mat-select placeholder="Select Unit" class="get-Input new-input"
                [(ngModel)]="selectedId"
                (selectionChange)="onUnitSelected($event.value)">
      <mat-option *ngFor="let unit of unitMeasures" [value]="unit.UnitId">
        {{unit.UnitMeasure | uppercase}}
      </mat-option>
    </mat-select>
  </div>

</div>



    <div class="input-container" *ngIf="questionTypeId==6 || IsConnectComp">
      <span class="info" title="If this question applies to a specific implement type, select the type.">
        <i class="material-icons sc-icon">info</i>
      </span>
      <span class="label">Implement Link</span>
      <mat-select placeholder="Select Implement Type" [(ngModel)]="impTypeId" class="new-input-select get-Input">
        <mat-option *ngFor="let impType of ImplementTypesList" [value]="impType.ImplementTypeId" (click)="LoadComponentTypes(impType.ImplementTypeId)">{{ impType.Name }}</mat-option>
      </mat-select>
    </div>


    <div class="input-container" *ngIf="noComponentTypesMsg">
      <span class="info">&nbsp;</span>
      <label class="longlabel">There is no Component Types for this Implement Type</label>
    </div>
    <div class="input-container" *ngIf="showComponentTypes">
      <span class="info">
        <i class="material-icons sc-icon">info</i>
      </span>
      <span class="label">Component Types</span>
      <!--!notypes &&  && impTypeId>0-->
      <!--<mat-selection-list *ngIf="!notypes && questionTypeId == 6" #types class="custom-scroll-bar"
                        [(ngModel)]="componentTypeIds">
      <mat-list-option *ngFor="let item of componetTypesList" [value]="item.Id" (click)="LoadComponent()">
        {{item.Name}}
      </mat-list-option>
    </mat-selection-list>-->
      <mat-select #types [(ngModel)]="componentTypeId"
                  class="new-input-select get-Input">
        <mat-option *ngFor="let item of componetTypesList" [value]="item.Id" (click)="LoadComponent()">
          {{item.Name}}
        </mat-option>
      </mat-select>
    </div>
    <div class="input-container" *ngIf="!noComponentTypesMsg && noComponentMsg">
      <span class="info">&nbsp;</span>
      <label class="longlabel">There is no Component for this Component Type</label>
    </div>
    <div class="input-container" *ngIf="showComponents">
      <span class="info">
        <i class="material-icons sc-icon">info</i>
      </span>
      <span class="label">Component</span>
      <!--<mat-selection-list *ngIf="!notypes && questionTypeId == 6 && impTypeId > 0" #types class="custom-scroll-bar"
                        [(ngModel)]="componentIds">
      <mat-list-option *ngFor="let item of ComponentList" [value]="item.Id" (click)="ShowSchematicList()">{{item.Name}}</mat-list-option>
    </mat-selection-list>-->
      <mat-select #types1 [(ngModel)]="componentId"
                  class="new-input-select get-Input">
        <mat-option *ngFor="let item of ComponentList" [value]="item.Id" (click)="PushToComponentId(); ShowSchematicList();">
          {{item.Name}}
        </mat-option>
      </mat-select>
    </div>
    <ng-container *ngIf="SchematicList != null  && questionTypeId==6">
      <ng-container *ngFor="let img of SchematicList">
        <img [src]="getImage(img)" class="selection__image" style="width: 505px;" />
      </ng-container>
    </ng-container>
  </div>
    <div class="ttmodal__footer">
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" (click)="onAddQuestion()"><span class="button__text">{{isQuestionEdit ? "Update Question" : "Add Question" }}</span></a>
    </div>
  </div>

